import AddInterpreter from 'components/interpreter/AddInterpreter';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { interpreterSelector } from 'slices/interpreterSlice';
import { fetchInterpreters } from 'slices/interpreterSlice';

const InterpreterUpdate = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { interpreter: interpreters,} = useSelector(interpreterSelector);
    const { id } = useParams();

    useEffect(() => {
        dispatch(fetchInterpreters());
    }, [dispatch]);

    if (!interpreters.length) return <div>Loading...</div>;

    const item = interpreters.find(t => t.id === Number(id));
    return (
        <div className='content'>
            <div className="row_main_head">
                <div className='d-flex align-items-center gap-2'>
                    <button className="main_heading back_button" onClick={() => navigate(-1)}>
                        <i className="fa-solid fa-arrow-left"></i> Back
                    </button>
                    <h2 className="main_heading">Update Accounts</h2>
                </div>
                {/* <LiveClock /> */}
            </div>

            {item ? <AddInterpreter item={item} /> : <div>Item not found</div>}
        </div>
    );
};

export default InterpreterUpdate;
